import axios from 'axios';

const url = process.env.VUE_APP_API_BASE_URL;

export default {
  namespaced: true,
  state: {
    items: [],
    meta: null,
    detail: null,
    loading: false,
    error: null,
  },
  mutations: {
    setLoading(state, loading) {
      state.loading = loading;
    },
    setItems(state, { items, meta }) {
      state.items = items || [];
      state.meta = meta || null;
      state.error = null;
    },
    setDetail(state, detail) {
      state.detail = detail || null;
      state.error = null;
    },
    setError(state, error) {
      state.error = error;
    },
  },
  actions: {
    async fetchList({ commit }, params = {}) {
      commit('setLoading', true);
      try {
        const queryParams = {
          mes: params.mes,
          search: params.search || undefined,
          estado: params.estado || undefined,
          estadoSat: params.estadoSat || undefined,
          idEmpleado: params.idEmpleado || undefined,
          refresh: params.refresh ? 'true' : undefined,
          includeKeikaku: params.includeKeikaku ? 'true' : undefined,
        };

        Object.keys(queryParams).forEach((key) => {
          if (queryParams[key] === undefined || queryParams[key] === '') {
            delete queryParams[key];
          }
        });

        const response = await axios.get(`${url}/vista-operativa`, {
          params: queryParams,
        });

        commit('setItems', {
          items: response.data.items || [],
          meta: response.data.meta || null,
        });

        return response.data;
      } catch (error) {
        const message =
          error.response?.data?.error?.message ||
          error.message ||
          'Error al cargar la vista de partes';
        commit('setError', message);
        throw error;
      } finally {
        commit('setLoading', false);
      }
    },
    async fetchDetail({ commit }, { id, refresh = false, includeKeikaku = true } = {}) {
      commit('setLoading', true);
      try {
        const response = await axios.get(`${url}/vista-operativa/${id}`, {
          params: {
            ...(refresh ? { refresh: 'true' } : {}),
            ...(includeKeikaku === false ? { includeKeikaku: 'false' } : {}),
          },
        });

        commit('setDetail', response.data);
        return response.data;
      } catch (error) {
        const message =
          error.response?.data?.error?.message ||
          error.message ||
          'Error al cargar el detalle del parte';
        commit('setError', message);
        throw error;
      } finally {
        commit('setLoading', false);
      }
    },
  },
  getters: {
    items: (state) => state.items,
    meta: (state) => state.meta,
    detail: (state) => state.detail,
    loading: (state) => state.loading,
    error: (state) => state.error,
  },
};
